import { render } from "./GrantsForm.vue?vue&type=template&id=6fe91d22&scoped=true"
import script from "./GrantsForm.vue?vue&type=script&lang=js"
export * from "./GrantsForm.vue?vue&type=script&lang=js"

import "./GrantsForm.vue?vue&type=style&index=0&id=6fe91d22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe91d22"]])

export default __exports__